import React from 'react';
import PropTypes from 'prop-types';
import Legend from '../legend/legend';
import {Pie} from 'react-chartjs-2';
/* Helpers */
import {generateLegendMarkup} from '../../../../helpers/chart-helpers';
import './pie-chart.scss';

class PieChart extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      legend: [],
    };
    this.chartRef = React.createRef();
    this.legendRef = React.createRef();
  }

  componentDidMount() {
    this.generateLegendMarkup();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.generateLegendMarkup();
    }
  }

  generateLegendMarkup = () => {
    const legend = this.chartRef && this.chartRef.current.chartInstance.generateLegend();
    this.setState({
      legend,
    });
  };

  legendMarkup = (chart) => {
    return generateLegendMarkup(chart, this.props.singleLabelRedirect);
  };

  handleLabelRedirect = (evt) => {
    if (!this.props.singleLabelRedirect) {
      return;
    }
    const activePoint = this.chartRef.current.chartInstance.getElementsAtEvent(evt)[0];
    if (activePoint) {
      /* eslint-disable no-underscore-dangle */
      const label = this.chartRef.current.props.data.labels[activePoint._index];
      // TODO Find other solution as there is no no suggested working fixes at the moment within react community
      setTimeout(() => {
        this.props.singleLabelRedirect(label);
      }, 0);
    }
  };

  render() {
    return (
      <>
        <Legend ref={this.legendRef} legend={this.state.legend} />
        <div className="glu-chart">
          <Pie
            ref={this.chartRef}
            data={this.props.data}
            options={{
              onClick: (evt) => this.handleLabelRedirect(evt),
              legend: {
                display: false,
                position: 'left',
                labels: {
                  fontColor: '#333D44',
                },
              },
              legendCallback: this.legendMarkup,
              cutoutPercentage: this.props.cutoutPercentage,
              maintainAspectRatio: false,
              tooltips: {
                displayColors: false,
                titleFontSize: 16,
                bodyFontSize: 14,
                xPadding: 10,
                yPadding: 10,
              },
            }}
          />
        </div>
      </>
    );
  }
}

PieChart.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  cutoutPercentage: PropTypes.number,
  singleLabelRedirect: PropTypes.func,
};

PieChart.defaultProps = {
  cutoutPercentage: 0,
  singleLabelRedirect: null,
};

export default PieChart;
